import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './EndNodeContent.module.scss';
import message from '../../../Containers/Connect/ConnectMessages';

export default function EndNodeContent(props) {
  const { drawerFooter } = props;
  return (
    <div style={{ width: 650 }}>
      <div className={styles.endNodeContent}><FormattedMessage {...message.doYouWantToEndTheWorkflowLabel}/> </div>
      <div className={styles.endDrawerFooter}>{drawerFooter}</div>
    </div>
  );
}
